export default __webpack_public_path__ + "static/media/337.e15d116c.png";